import {
  useCreateRoomMutation,
  useDeleteRoomMutation,
  useGetAllRoomsQuery,
  useUpdateRoomMutation,
} from "../../../services/api/locationsApi";
import { FloorModel } from "app/services/api/types/locations/models/FloorModel";
import { RoomRequest } from "app/services/api/types/locations/requests/RoomRequest";
import { useDisplayToast } from "ui/hooks/useDisplayToast";

interface Props {
  locationId?: number;
  floor?: FloorModel;
}
export const useRoomManagement = ({ floor, locationId }: Props) => {
  const { showErrorToast } = useDisplayToast();

  const [triggerCreateRoom] = useCreateRoomMutation();
  const [triggerUpdateRoom] = useUpdateRoomMutation();
  const [triggerDeleteRoom] = useDeleteRoomMutation();

  const { data: rooms, isFetching } = useGetAllRoomsQuery(
    { filter: { floor_id: floor?.id, location_id: locationId } },
    {
      skip: !floor?.id || !locationId,
    },
  );

  const handleDeleteRoom = async (roomId: number) => {
    try {
      await triggerDeleteRoom({ roomId, locationId: locationId! }).unwrap();
    } catch (e) {
      showErrorToast(e);
    }
  };

  const handleCreateRoom = async (data: RoomRequest) => {
    try {
      await triggerCreateRoom({ body: data, locationId: locationId! }).unwrap();
    } catch (e) {
      showErrorToast(e);
    }
  };

  const handleUpdateRoom = async (roomId: number, data: RoomRequest) => {
    try {
      await triggerUpdateRoom({
        roomId,
        body: data,
        locationId: locationId!,
      }).unwrap();
    } catch (e) {
      showErrorToast(e);
    }
  };

  return {
    rooms: !floor?.id || !locationId ? [] : rooms,
    deleteRoom: handleDeleteRoom,
    updateRoom: handleUpdateRoom,
    createRoom: handleCreateRoom,
    areRoomsFetching: isFetching,
  };
};
